class FinAgentService {
    lastError;
    lastResponseCode;
    currentRequest = {};

    constructor(axios) {
        this.axios = axios
    }

    async getMessages(threadId) {
        if (this.currentRequest.fetchMessages) {
            await this.currentRequest.fetchMessages.cancel();
        }

        const axiosSource = this.axios.CancelToken.source();
        this.currentRequest.fetchMessages = { cancel: axiosSource.cancel };
        const url = `/api/finagent/thread/${threadId}/messages`;

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async pollMessage(threadId, userMessageId, opt = {}) {
        if (this.currentRequest.pollMessage) {
            await this.currentRequest.pollMessage.cancel();
        }

        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.pollMessage = { cancel: axiosSource.cancel };
        const url = `/api/finagent/thread/${threadId}/messages/poll/${userMessageId}`;

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getThreads() {
        if (this.currentRequest.getThreads) {
            await this.currentRequest.getThreads.cancel();
        }

        const axiosSource = this.axios.CancelToken.source();
        this.currentRequest.getThreads = { cancel: axiosSource.cancel };
        const url = '/api/finagent/threads';

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async createMessage({
        threadId,
        message,
        avoidInvestmentAdvice,
        avoidConsideringPortfolioData,
    }) {
        const data = { message, avoidInvestmentAdvice, avoidConsideringPortfolioData };
        const url = `/api/finagent/thread/${threadId}/message`;
        return await this
            .axios
            .post(url, data)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async createThread() {
        const url = '/api/finagent/thread';
        return await this
            .axios
            .post(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async createThreadFromFaq(faqId) {
        const url = `/api/finagent/thread/from-faq/${faqId}`;
        return await this
            .axios
            .post(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async deleteThread(threadId) {
        const url = '/api/finagent/thread/';
        return await this
            .axios
            .delete(url + threadId)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async renameThread(threadId, threadTitle) {
        const url = '/api/finagent/thread/';
        const data = {
            threadTitle
        }
        return await this
            .axios
            .put(url + threadId, data)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getProfile() {
        if (this.currentRequest.getProfile) {
            await this.currentRequest.getProfile.cancel();
        }

        const axiosSource = this.axios.CancelToken.source();
        this.currentRequest.getProfile = { cancel: axiosSource.cancel };
        const url = '/api/finagent/profile';

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async createSnippet(messageId, title) {
        const url = '/api/finagent/library';
        const data = { title, messageId };
        return await this
            .axios
            .post(url, data)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }
 
    async deleteSnippet(id) {
        const url = `/api/finagent/library/${id}`;

        return await this
            .axios
            .delete(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async massDeleteSnippets(ids = []) {
        const url = '/api/finagent/library/massdelete';

        return await this
            .axios
            .post(url, { ids })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getSnippets(keyWord = '',opt = {}) {
        if (this.currentRequest.getSnippets) {
            await this.currentRequest.getSnippets.cancel();
        }

        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.getSnippets = { cancel: axiosSource.cancel };
        const url = '/api/finagent/library';
        const params = {
            params: {
                q: keyWord,
            },
            cancelToken: axiosSource.token,
        };
       
        return await this
            .axios
            .get(url, params)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getSnippetDetail(id, opt = {}) {
        if (this.currentRequest.getSnippetDetail) {
            await this.currentRequest.getSnippetDetail.cancel();
        }

        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.getSnippetDetail = { cancel: axiosSource.cancel };
        const url = `/api/finagent/library/${id}`;

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async updateSnippetTitle(id, title) {
        const url = `/api/finagent/library/${id}`;
        const data = { title };
        return await this
            .axios
            .put(url, data)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }
    
    async attachSnippetToThread(threadId, snippetIds) {
        const url = `/api/finagent/library/attach/${threadId}`;

        return await this
            .axios
            .put(url, { ids: snippetIds })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async detachSnippetFromThread(threadId, snippetIds) {
        const url = `/api/finagent/library/detach/${threadId}`;

        return await this
            .axios
            .put(url, { ids: snippetIds })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getUsage() {
        const url = '/api/finagent/usage';

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getWishListItems (keyWord = '', opt = {}) {
        if (this.currentRequest.getWishListItems) {
            await this.currentRequest.getWishListItems.cancel();
        }

        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.getWishListItems = { cancel: axiosSource.cancel };
        const url = '/api/finagent/wishlist';
        const params = {
            params: {
                q: keyWord,
            },
            cancelToken: axiosSource.token,
        };
       
        return await this
            .axios
            .get(url, params)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getWishListIsins() {
        return await this
            .axios
            .get('/api/finagent/wishlist')
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data?.map(c => c.isin)
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async addToWatchList (isin) {
        return await this
            .axios
            .post('/api/finagent/wishlist/add', { isin })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async removeFromWatchList (isin) {
        return await this
            .axios
            .post('/api/finagent/wishlist/remove', { isin })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async massRemoveFromWatchList (isins) {
        return await this
            .axios
            .post('/api/finagent/wishlist/massdelete', { isins })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async createAutoAskQuestion(dataToCreate) {
        return await this
            .axios
            .post('/api/finagent/recurring', { ...dataToCreate })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async updateAutoAskQuestion(id, dataToUpdate) {
        return await this
            .axios
            .put(`/api/finagent/recurring/${id}`, { ...dataToUpdate })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getAutoAskQuestion(id, axiosSource = {}) {
        return await this
            .axios
            .get(`/api/finagent/recurring/${id}`, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getAutoAskQuestions (keyWord = '', opt = {}) {
        if (this.currentRequest.getAutoAskQuestions) {
            await this.currentRequest.getAutoAskQuestions.cancel();
        }

        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.getAutoAskQuestions = { cancel: axiosSource.cancel };
        const url = '/api/finagent/recurring';
        const params = {
            params: {
                q: keyWord,
            },
            cancelToken: axiosSource.token,
        };
       
        return await this
            .axios
            .get(url, params)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async massRemoveAutoAskQuestions (ids) {
        return await this
            .axios
            .post('/api/finagent/recurring/massdelete', { ids })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getAutoAskAnswers(runThreadId, opt = {}) {
        if (this.currentRequest.getAutoAskAnswers) {
            await this.currentRequest.getAutoAskAnswers.cancel();
        }
        const axiosSource = opt.axiosSource || this.axios.CancelToken.source();
        this.currentRequest.getAutoAskAnswers = { cancel: axiosSource.cancel };
        const url = `/api/finagent/thread/${runThreadId}/messages`;

        return await this
            .axios
            .get(url, { cancelToken: axiosSource.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    handleError(e) {
        this.lastResponseCode = e.response?.status || e.code;
        this.lastError = e.response?.statusText || e.message;

        throw e;
    }
}

export default FinAgentService
